import React from 'react';
import { Link } from 'react-router-dom';

export function PlayStoreBadge({ href, name }) {
  return (
    <a
      className="loksy-play-badge"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="/images/google-play-badge.png"
        alt={`Get ${name || 'the app'} on Google Play`}
      />
    </a>
  );
}

function WebsiteIcon() {
  return (
    <svg className="loksy-website-icon" viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.7" />
      <path
        d="M3 12h18M12 3c2.6 3.1 3.9 6.2 3.9 9s-1.3 5.9-3.9 9c-2.6-3.1-3.9-6.2-3.9-9S9.4 6.1 12 3z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
      />
    </svg>
  );
}

export function WebsiteLink({ to, children, tone = 'dark' }) {
  return (
    <Link className={`loksy-btn loksy-btn-website ${tone}`} to={to}>
      <WebsiteIcon />
      <span className="loksy-website-copy">
        <span className="loksy-website-kicker">Website</span>
        <span>{children}</span>
      </span>
    </Link>
  );
}
